export default "__VITE_ASSET__CNICpdXX__"